<!--  -->
<template>
  <div class="main">
    <div class="form-screen">
      <a-input-search
        placeholder="投放站点名"
        style="width: 240px"
        class="screen-option"
        enterButton
        @search="onSerch"
      ></a-input-search>
      <a-button type="primary" @click="editAdv('add')">新建广告投放</a-button>
    </div>
    <a-table
      :columns="columns"
      :rowKey="(record) => record.id"
      :dataSource="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="status" slot-scope="status">
        <span v-if="status == 1" class="green">投放中</span>
        <span v-else class="red">停用</span>
      </template>
      <template slot="time" slot-scope="time, record">
        <span>{{ record.pubstart }}</span> -
        <span v-if="record.pubend != null">{{ record.pubend }}</span>
        <span v-else>不限结束时间</span>
      </template>
      <template slot="goodslist" slot-scope="goodslist">
        <!-- <p v-for="(g, index) in goodslist" :key="index" v-if()>{{ g }}</p> -->
        <div v-if="goodslist.length == 1" class="link">{{ goodslist[0] }}</div>
        <div v-if="goodslist.length > 1">
          <a-popover title="物料详情" placement="right">
            <template slot="content" v-for="(item, index) in goodslist">
              <p :key="index">{{ item }}</p>
            </template>
            <span class="link">{{ goodslist.length }}个物料</span>
          </a-popover>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-button
          type="primary editable-add-btn"
          @click="editAdv('edit', record)"
        >
          <a-icon type="edit" />编辑
        </a-button>

        <a-popconfirm
          title="确认删除么"
          okText="确定"
          cancelText="取消"
          @confirm="del(record.id)"
        >
          <a-button type="danger" :style="{ marginLeft: '8px' }">
            <a-icon type="delete" />删除
          </a-button>
        </a-popconfirm>
      </template>
    </a-table>
    <a-drawer
      :title="drawerTitle"
      placement="right"
      :closable="true"
      @close="materielVisible = false"
      :visible="materielVisible"
      :width="1500"
      :destroyOnClose="true"
    >
      <a-row>
        <a-col :span="15">
          <a-form :form="form" layout="vertical" @submit="complete">
            <a-form-item label="投放名称：">
              <a-input
                v-decorator="[
                  'title',
                  {
                    rules: [
                      {
                        required: true,
                        max: 100,
                        message: '投放名称必填,且不超过100个字',
                      },
                    ],
                    validateTrigger: 'blur',
                  },
                ]"
                placeholder="请输入投放名称"
              />
            </a-form-item>
            <a-form-item label="id" style="display: none">
              <a-input v-decorator="['id']" />
            </a-form-item>

            <a-form-item label="投放时间：" class="margin-b-5">
              <a-radio-group
                name="radioGroup"
                v-decorator="[
                  'target',
                  {
                    initialValue: '1',
                    rules: [
                      {
                        required: true,
                      },
                    ],
                  },
                ]"
                @change="TimeTypeChange"
              >
                <a-radio :value="'1'">不限结束时间</a-radio>
                <a-radio :value="'2'">设定结束时间</a-radio>
              </a-radio-group>
            </a-form-item>
            <div class="top-border-panel">
              <a-form-item
                label="开始时间："
                v-if="timeType == 1"
                class="margin-b-5"
              >
                <a-date-picker
                  v-decorator="[
                    'startTime',
                    {
                      initialValue: startTime,
                    },
                  ]"
                  :disabledDate="disabledStartDate"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="开始时间"
                />
              </a-form-item>
              <a-row v-if="timeType == 2">
                <a-col :span="24">
                  <a-form-item label="开始时间：" class="margin-b-5">
                    <a-date-picker
                      v-decorator="[
                        'pubstart',
                        {
                          rules: [
                            {
                              type: 'object',
                              required: true,
                              message: '开始时间必填',
                            },
                          ],
                        },
                      ]"
                      :disabledDate="advStartDate"
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      placeholder="开始时间"
                      @openChange="startOpenChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="结束时间：" class="margin-b-5">
                    <a-date-picker
                      v-decorator="[
                        'pubend',
                        {
                          rules: [
                            {
                              type: 'object',
                              required: true,
                              message: '结束时间必填',
                            },
                          ],
                        },
                      ]"
                      :disabledDate="advEndDate"
                      showTime
                      :open="endOpen"
                      format="YYYY-MM-DD HH:mm:ss"
                      placeholder="结束时间"
                      @openChange="endOpenChange"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <a-form-item label="目标广告位：">
              <a-select
                v-decorator="[
                  'posids',
                  {
                    rules: [
                      {
                        required: true,
                        message: '广告位必填',
                      },
                    ],
                  },
                ]"
                showSearch
                placeholder="搜索广告位"
                optionFilterProp="children"
              >
                <a-select-option
                  v-for="d in advPosition"
                  :key="d.id"
                  :value="d.id"
                  :disabled="d.disabled"
                  >{{ d.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="广告物料：">
              <a-input
                v-decorator="[
                  'goodsids',
                  {
                    rules: [{ required: true, message: '物料必选' }],
                  },
                ]"
                style="display: none"
              />
              <a-table
                :columns="materielColumns"
                :rowKey="(record) => record.id"
                :dataSource="materielData"
                :bordered="true"
                :scroll="{ y: 240 }"
                :pagination="{ pageSize: 10 }"
              >
                <template slot="title">
                  <div class="but">
                    <a-button
                      type="primary"
                      @click="
                        (matterTableVisible = true), (selectedRowKeys = [])
                      "
                    >
                      从物料库中选择
                    </a-button>
                  </div>
                </template>
                <template slot="picture" slot-scope="picture">
                  <img :src="picture" alt="" width="200" :height="40" />
                </template>
                <template slot="size" slot-scope="record">
                  <span>{{ record.width }}*{{ record.height }}</span>
                </template>
                <template slot="operation" slot-scope="text, record, index">
                  <a-popconfirm
                    title="确认移除么"
                    okText="确定"
                    cancelText="取消"
                    @confirm="materielDel(record.id)"
                  >
                    <a href="javascript:;">移除</a>
                  </a-popconfirm>
                  <a-icon
                    type="up-circle"
                    class="margin-l-5 soft"
                    @click="materSort('up', index)"
                  />
                  <a-icon
                    type="down-circle"
                    class="margin-l-5 soft"
                    @click="materSort('down', index)"
                  />
                </template>
                <template slot="order" slot-scope="text, record, index">
                  <span>{{ index + 1 }}</span>
                </template>
              </a-table>
            </a-form-item>
            <a-form-item label="是否启用：">
              <a-switch
                v-decorator="[
                  'switch',
                  { valuePropName: 'checked', initialValue: true },
                ]"
                checkedChildren="启用"
                unCheckedChildren="停用"
              />
            </a-form-item>

            <a-form-item>
              <a-button type="primary" html-type="submit"> 保存 </a-button>
              <a-button
                :style="{ marginLeft: '8px' }"
                @click="materielVisible = false"
              >
                取消
              </a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
      <a-drawer
        title="物料库"
        width="1000"
        :closable="true"
        @close="matterTableVisible = false"
        :visible="matterTableVisible"
      >
        <div style="margin-bottom: 60px">
          <a-input-search
            placeholder="请输入物料名称"
            style="width: 240px"
            class="screen-option"
            enterButton
            @search="matterOnSerch"
          ></a-input-search>
          <a-table
            :columns="matterColumns"
            :rowKey="(record) => record.id"
            :dataSource="matterData"
            :pagination="matterPagination"
            :loading="matterLoading"
            @change="matterHandleTableChange"
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
          >
            <template slot="name" slot-scope="name">
              {{ name }}
            </template>
            <template slot="picture" slot-scope="picture">
              <img :src="picture" alt="" width="200" :height="40" />
            </template>
            <template slot="size" slot-scope="record">
              <span>{{ record.width }}*{{ record.height }}</span>
            </template>
          </a-table>
        </div>
        <div class="materiel-dra">
          <a-divider />
          <a-button type="primary" @click="matterAdd"> 添加 </a-button>
          <a-button
            :style="{ marginLeft: '8px' }"
            @click="matterTableVisible = false"
          >
            取消
          </a-button>
        </div>
      </a-drawer>
    </a-drawer>
  </div>
</template>

<script>
const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
    align: 'center'
  },
  {
    title: '名称',
    dataIndex: 'title',
    scopedSlots: { customRender: 'title' },
    align: 'center'
  },
  {
    title: '广告位',
    dataIndex: 'position',
    scopedSlots: { customRender: 'position' },
    align: 'center'
  },
  {
    title: '物料',
    dataIndex: 'goodslist',
    scopedSlots: { customRender: 'goodslist' },
    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center',
    width: 200
  },
  {
    title: '投放时间',
    scopedSlots: { customRender: 'time' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
];
const materielColumns = [
  {
    title: '物料料名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    width: 200
  },
  {
    title: '广告物料缩略图',
    dataIndex: 'picture',
    scopedSlots: { customRender: 'picture' },
    width: 300
  },
  {
    title: '尺寸',
    scopedSlots: { customRender: 'size' },
    width: 120
  },
  {
    title: '播放顺序',
    scopedSlots: { customRender: 'order' },
    width: 100
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
];
const matterColumns = [
  {
    title: '编号',
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
    sorter: (a, b) => a.id - b.id
  },
  {
    title: '广告物料名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '广告物料缩略图',
    dataIndex: 'picture',
    width: '300px',
    scopedSlots: { customRender: 'picture' },
    align: 'center'
  },
  {
    title: '尺寸',
    scopedSlots: { customRender: 'size' },
    align: 'center',
    with: '150px'
  }
];
import moment from 'moment';
export default {
  components: {},
  data() {
    return {
      columns,
      materielColumns,
      matterColumns,
      drawerTitle: '广告位',
      materielData: [], //广告位物料详情表
      matterData: [], //所有物料列表
      selectedRowKeys: [], //物料表选择项
      startTime: moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
      data: [], //表格数据
      pagination: {},
      matterPagination: {},
      loading: true,
      matterLoading: true,
      limit: 10,
      materielVisible: false,
      matterTableVisible: false,
      form: this.$form.createForm(this),
      endOpen: false,
      timeType: 1, //是否开启物料投放结束时间
      matterList: [],
      advPosition: [],
      adlistdata: []
    };
  },
  computed: {},

  watch: {},

  methods: {
    filterRepeat(arr, prop) {
      return arr.filter(function (element, index, self) {
        return self.findIndex(el => el[prop] == element[prop]) === index;
      });
    },
    //投放列表
    fetch(params = {}) {
      this.$http.post('/api/ad/playlist', params).then(res => {
        const pagination = { ...this.pagination };
        if (res.data.state == 200) {
          // pagination.total = data.totalCount;
          pagination.total = 10 * res.data.pages;
          this.loading = false;
          this.data = res.data.data;
        } else {
          this.loading = false;
          pagination.total = 0;
          this.data = [];
        }
        this.pagination = pagination;
      });
    },
    //搜索广告
    onSerch(value, event) {
      this.fetch({
        limit: this.limit,
        title: value
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.loading = true;
      this.fetch({
        limit: this.limit,
        page: pagination.current
      });
    },
    matterHandleTableChange(pagination, filters, sorter) {
      const pager = { ...this.matterPagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.loading = true;
      this.matterFetch({
        limit: this.limit,
        page: pagination.current
      });
    },
    //限制投放开始时间
    disabledStartDate(current) {
      return current < moment().subtract(1, 'day');
    },
    TimeTypeChange(e) {
      this.timeType = e.target.value;
    },
    advStartDate(startValue) {
      const endValue = this.form.getFieldValue('pubend');
      if (startValue < moment().subtract(1, 'day')) {
        return true;
      }
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    advEndDate(endValue) {
      const startValue = this.form.getFieldValue('pubstart');
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    startOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    endOpenChange(open) {
      this.endOpen = open;
    },
    //根据查找物料
    materielFetch(params = {}) {
      this.$http.post('/api/ad/playdetail', params).then(res => {
        if (res.data.state == 200) {
          if (res.data.data.goodslist[0]) {
            this.materielData = res.data.data.goodslist;
          } else {
            this.materielData = [];
          }

        }
      });
    },
    //编辑/新增投放
    editAdv(type, record) {
      this.contrast(type, record);
      this.materielVisible = true;
      if (type === 'edit') {
        this.$nextTick(function () {
          let target = '1';
          let start = moment(record.pubstart, 'YYYY-MM-DD HH:mm:ss');
          let end = null;
          if (record.pubend == null) {
            target = '1';
            this.form.setFieldsValue({
              target,
              startTime: start
            });
          } else {
            target = '2';
            end = moment(record.pubend, 'YYYY-MM-DD HH:mm:ss');
            this.form.setFieldsValue({
              target,
              pubstart: start,
              pubend: end
            });
          }
          if (record.status == 1) {
            this.form.setFieldsValue({
              switch: true
            });
          }
          this.form.setFieldsValue({
            id: record.id ? record.id : '',
            title: record.title,
            goodsids: record.goodsids,
            posids: record.posid
          });

          this.drawerTitle = '编辑广告物料';
          this.materielFetch({
            id: record.id
          });
        });
      } else {
        this.drawerTitle = '新建广告物料';
        this.materielData = [];
      }
    },
    //删除投放
    del(id) {
      this.$http
        .post('/api/ad/playdel', {
          ids: id
        })
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('删除成功');
            this.fetch({ limit: this.limit });
          } else {
            this.$message.error('操作失败，请重试');
          }
        });
    },
    //移除广告投放中物料
    materielDel(id) {
      let list = this.materielData;
      let goodsids = this.form.getFieldValue('goodsids').split(',');
      let curr = list.findIndex(item => {
        return item.id == id;
      });
      this.materielData.splice(curr, 1);
      let curr2 = goodsids.findIndex(item => {
        return item == id;
      });
      goodsids.splice(curr2, 1);
      this.form.setFieldsValue({
        goodsids: goodsids.join(',')
      });
    },
    //查找所有物料
    matterFetch(params = {}) {
      this.$http.post('/api/ad/goodslist', params).then(res => {
        const pagination = { ...this.matterPagination };
        if (res.data.state == 200) {
          pagination.total = 10 * res.data.pages;
          this.matterLoading = false;
          this.matterData = res.data.data;
          this.matterList = this.matterList.concat(res.data.data);
          this.matterList = this.filterRepeat(this.matterList, 'id');
        } else {
          this.matterLoading = false;
          pagination.total = 0;
          this.data = [];
        }
        this.matterPagination = pagination;
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    //搜索物料
    matterOnSerch(value, event) {
      this.matterFetch({
        limit: this.limit,
        name: value
      });
    },
    //选择广告位
    advSite() {
      this.$http.post('/api/ad/positionlist', { limit: 999 }).then(res => {
        if (res.data.state == 200) {
          this.advPosition = res.data.data;
        }
      });
    },
    //从物料库中添加物料
    matterAdd() {
      let optId = this.selectedRowKeys;
      let id = [];
      let data = [...this.materielData];
      this.matterList.forEach(item => {
        optId.forEach(item2 => {
          if (item2 == item.id) {
            data.push(item);
          }
        });
      });
      data = this.filterRepeat(data, 'id');
      data.forEach(item => {
        id.push(item.id);
      });
      this.materielData = data;
      this.matterTableVisible = false;
      this.form.setFieldsValue({
        goodsids: id.join(',')
      });
    },
    //物料播放顺序调整
    materSort(type, index) {
      let data = [...this.materielData];
      if (type == 'up') {
        if (index <= 0) {
          return false;
        } else {
          let after = data[index];
          let front = data[index - 1];
          data[index - 1] = after;
          data[index] = front;
        }
      } else if (type == 'down') {
        if (index >= this.materielData.length - 1) {
          return false;
        } else {
          let front = data[index];
          let after = data[index + 1];
          data[index + 1] = front;
          data[index] = after;
        }
      }
      let goodsids = [];
      data.forEach(item => {
        goodsids.push(item.id);
      });
      this.form.setFieldsValue({
        goodsids: goodsids.join(',')
      });
      this.materielData = data;
    },
    contrast(type, record) {
      let that = this;
      that.adlistdata.forEach(item => {
        that.advPosition.forEach(item2 => {
          if (item.posid == item2.id) {
            item2.disabled = true;
          }
        });
      });
      if (type === 'edit') {
        that.advPosition.forEach(item => {
          if (record.posid == item.id) {
            item.disabled = false;
          }
        });
      }
    },
    //提交广告投放表
    complete(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            id: values.id ? values.id : '',
            title: values.title,
            goodsids: values.goodsids,
            posids: values.posids
          };
          if (values.target == 1) {
            params.pubstart = moment(
              values.startTime,
              'YYYY-MM-DD HH:mm:ss'
            ).format('YYYY-MM-DD HH:mm:ss');
          } else {
            params.pubstart = moment(
              values.pubstart,
              'YYYY-MM-DD HH:mm:ss'
            ).format('YYYY-MM-DD HH:mm:ss');
            params.pubend = moment(values.pubend, 'YYYY-MM-DD HH:mm:ss').format(
              'YYYY-MM-DD HH:mm:ss'
            );
          }
          if (values.switch) {
            params.pause = -1;
          } else {
            params.pause = 1;
          }
          this.$http.post('/api/ad/playupdate', params).then(res => {
            if (res.data.state == 200) {
              if (params.id == '') {
                this.$message.success('添加成功');
              } else {
                this.$message.success('编辑成功');
              }
              this.fetch({ limit: this.limit });
              this.materielVisible = false;
            } else {
              this.$message.error('操作失败，请重试');
            }
          });
        }
      });
    }
  },
  created() { },
  mounted() {
    this.fetch({ limit: this.limit });
    this.matterFetch({ limit: this.limit });
    this.advSite();
    this.$http.post('/api/ad/playlist', { limit: 9999 }).then(res => {
      this.adlistdata = res.data.data;
    });
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.screen-option {
  margin-right: 10px;
  margin-bottom: 10px;
}
.margin-b-5 {
  margin-bottom: 5px;
}
.margin-l-5 {
  margin-left: 5px;
}
.top-border-panel {
  padding: 20px;
  border-top: 3px solid #dfdfdf;
  background-color: #f8f8f8;
  margin-bottom: 15px;
}
.link {
  color: #12bfcd;
}
.green {
  color: #6ac891;
}
.red {
  color: #ff8555;
}
.materiel-dra {
  position: fixed;
  top: 90%;
  width: 100%;
  height: 100px;
  background: #fff;
}
.soft {
  font-size: 16px;
  cursor: pointer;
}
</style>
